module.exports = __webpack_public_path__ + "img/fondo_lateral_navidad.d2da915b.png";